import ResizeObserver from 'resize-observer-polyfill';

const isServer = typeof window === 'undefined';

const resizeHandler = function(entries) {
  for (let i = 0; i < entries.length; i++) {
    const entry = entries[i];
    const listeners = entry.target.__resizeListeners__ || [];
    if (listeners.length) {
      listeners.forEach((fn) => {
        fn();
      });
    }
  }
};

export const addResizeListener = function(_el, callback) {
  const el = _el;
  if (isServer || el.nodeType !== 1) return;
  if (!el.__resizeListeners__) {
    el.__resizeListeners__ = [];
    el.__ro__ = new ResizeObserver(resizeHandler);
    el.__ro__.observe(el);
  }
  el.__resizeListeners__.push(callback);
};

export const removeResizeListener = function(el, callback) {
  if (!el || !el.__resizeListeners__) return;
  el.__resizeListeners__.splice(el.__resizeListeners__.indexOf(callback), 1);
  if (!el.__resizeListeners__.length) {
    el.__ro__.disconnect();
  }
};
